module.exports = __webpack_public_path__ + "img/pcn.c4a2e49f.svg";